import { FormTextField, FormTextFieldProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props extends Omit<FormTextFieldProps, "name" | "multiline" | "rows"> {
  name?: string;
  rows?: number;
}

export const FormTextFieldNotes = ({ name = "notes", rows = 5, label, placeholder, fullWidth, ...props }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <FormTextField
      fullWidth={fullWidth ?? true}
      label={label ?? t("common:form.text.field.notes.label")}
      multiline
      name={name}
      placeholder={placeholder ?? t("common:form.text.field.notes.placeholder")}
      rows={rows}
      {...props}
    />
  );
};
